/** @jsxImportSource @emotion/react */
import {
  Box,
  Display,
  Heading1,
  JustifyContent,
  FlexDirection,
  Space,
  Visible,
} from '@gousto-internal/citrus-react'
import { Hero } from '../Hero'
import { SearchBar } from '../SearchBar'

type SearchHeroProps = {
  searchInitValue: string
}

const SearchHero = ({ searchInitValue }: SearchHeroProps) => (
  <Hero paddingH={[3, 6]}>
    <Box
      display={Display.Flex}
      flexDirection={FlexDirection.Column}
      justifyContent={JustifyContent.SpaceBetween}
    >
      <Visible display={[Display.None, Display.Block]}>
        <Heading1 size={[5, 6, 7]}>
          Search for help
        </Heading1>
        <Space size={3} />
      </Visible>
      <Box width="100%" maxWidth={['100%', '24rem']}>
        <SearchBar
          isLoading={false}
          initValue={searchInitValue}
        />
      </Box>
    </Box>
  </Hero>
)

export { SearchHero }
